import ApiService from "../../../services/api.service";

const AirCafeCategoryService = {

	create(data) {
		return ApiService.post(`/aircafe-category/create`, data)
	},
	update(id, data) {
		return ApiService.put(`/aircafe-category/update/${id}`, data)
	},
	list(search) {
		return ApiService.post(`/aircafe-category/list-search?search=${search}`, {page: 1, limit: 10000})
	},
	changeStatus(data) {
		return ApiService.get(`/aircafe-category/change-status/${data.id}?status=${data.status}`);
	}

}

export default AirCafeCategoryService
